export default __webpack_public_path__ + "static/Comet-f37e10afa57324195fe9b29dfe350114.svg";